/**
 * StaffChangePasswordRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StaffChangePasswordRes
 */
export interface StaffChangePasswordRes {
  /** 修改成功 */
  success?: boolean
}

/**
 * StaffChangePasswordRes Schema
 */
export const StaffChangePasswordResSchema: SchemaDefinition = {
  properties: {
    success: {
      description: '修改成功',
      format: 'bool',
      type: 'boolean',
      label: '修改成功',
    },
  },
  type: 'object',
}
